import AuthLayout from '../components/auth/AuthLayout'
import LoginForm from '../components/auth/LoginForm'
import MetaTags from '../components/common/MetaTags'

export default function LoginPage() {
  return (
    <AuthLayout>
      <MetaTags
        title="Login | profile.work"
        description="Sign in to your profile.work account to manage your professional profile."
      />
      <LoginForm />
    </AuthLayout>
  )
}
